module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/images/Stills_6_viddsee_devices-8e9a77b905d5a292bc8fc8280c4e6a94.png";